import {
    B2BFooterViewModel,
    B2BSiteContextModel,
} from '@/types/B2BcontentServerContract';
import siteContextStore from '@/shared/content/site-context.store';

class SiteContextService {
    private get settings(): B2BSiteContextModel {
        return siteContextStore.settings as B2BSiteContextModel;
    }

    get resetPasswordSettings(): string {
        return this.settings.resetPasswordSettings;
    }

    get logoutEndpointUrl(): string {
        return this.settings.logoutEndpoint;
    }

    get frontpageUrl(): string {
        return this.settings.frontPageUrl;
    }

    get isNewCheckOutEnabled(): boolean {
        return this.settings.isNewCheckOutEnabled;
    }

    public get footer(): B2BFooterViewModel {
        return this.settings?.footer ?? {
            columns: [],
            copyrightText: 'string',
        };
    }
}

export default new SiteContextService();
